import { ColumnsType } from "antd/es/table";
import AntTable from "../../components/table/Table";
import {
    EditOutlined,
    DeleteOutlined
} from "@ant-design/icons";
import { Avatar, Button, Flex, Modal, Popconfirm, Space, Tooltip, notification } from "antd";
import { useState } from "react";
import moment from "moment";
import EditMember from "./EditMember";
import { MemberService } from "../../services/MemberService";
import Filter from "./Filter";

export default function User() {

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [editRecord, setEditRecord] = useState<object>()
    const [refreshData, setRefreshData] = useState<boolean>(false)
    const [filters, setFilters] = useState<any>()

    const [columns] = useState<ColumnsType<any>>([
        {
            title: 'Id',
            align: 'center',
            dataIndex: 'id',
            key: 'id',
            render: (value, record) => {
                return <Tooltip title={`Unique id: ${record.unique_id}`}>{value}</Tooltip>
            },
        },
        {
            title: 'Name',
            align: 'center',
            dataIndex: 'fullname',
            key: 'fullname',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Email',
            align: 'center',
            dataIndex: 'email',
            key: 'email',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Mobile',
            align: 'center',
            dataIndex: 'tel',
            key: 'tel',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'My Ref. Code',
            align: 'center',
            sorter: true,
            dataIndex: 'my_reference_code',
            key: 'my_reference_code',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Agent Code',
            align: 'center',
            dataIndex: 'reference_code',
            key: 'reference_code',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'User Level',
            align: 'center',
            dataIndex: 'customer_level_name',
            key: 'customer_level_name',
            render: (value, record) => {
                return value;
                // return <Tooltip title={<div>
                //     {`Remain Volume: ${record.remaining_volume}`}<br></br>
                //     {`Remain Transactions: ${record.remaining_transactions}`}
                // </div>}>{value}</Tooltip>
            },
        },
        {
            title: 'Affiliate Level',
            align: 'center',
            dataIndex: 'affiliate_level_name',
            key: 'affiliate_level_name',
            render: (value, record) => {

                if (record?.affiliate_status == 'ACTIVE') {
                    return <Tooltip title={<div>
                        {/* {`Next Level Name: ${record.next_affiliate_level_name}`}<br></br>
                        {`Remain Transactions: ${record.next_affiliate_remain_transaction}`} */}
                    </div>}>{value}</Tooltip>
                } else {
                    return '-'
                }

            },
        },
        {
            title: 'Registered Date',
            align: 'center',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (value, record) => {
                return moment(value).isValid() ? moment(value).format('DD-MM-YYYY HH:mm') : null
            },
        },
        {
            title: 'Actions',
            align: 'center',
            dataIndex: 'actions',
            key: 'created_at',
            render: (text, record: any) => {
                return (
                    <Flex gap="small" justify="center" wrap="wrap">
                        <span onClick={() => {
                            setIsModalOpen(true)
                            setEditRecord(record)
                        }} >
                            <Button type="primary" icon={<EditOutlined></EditOutlined>}></Button>
                        </span>
                        <Popconfirm
                            placement="left"
                            title="Delete the account"
                            description="You cannot rollback this user."
                            okText="Yes"
                            cancelText="No"
                            onConfirm={(e) => {
                                deleteMember(record)
                            }}
                        >
                            <Button type="primary" danger icon={<DeleteOutlined></DeleteOutlined>}></Button>
                        </Popconfirm>
                    </Flex>
                )
            }
        },

    ])

    const onLoadData = async (params: any = {}) => {
        const payload = {
            ...params,
            ...filters
        }
        const res = await MemberService.getMembers(payload)
        return res
    }


    const exportReport = async () => {
        const data = {
            month: filters.month || moment().format('MM'),
            year: filters.year || moment().format('YYYY')
        }
        await MemberService.exportUsers(data)
    }


    const deleteMember = async (member: any) => {

        const res = await MemberService.deleteMember(member.id)

        if (res.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            setRefreshData(p => !p)
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    }

    const onFilters = (data: object) => {
        setFilters(data)
        setRefreshData(p => !p)
    }


    return (
        <>
            <Modal
                width={1000}
                title=""
                open={isModalOpen}
                onOk={() => setIsModalOpen(true)}
                onCancel={() => setIsModalOpen(false)}
                footer={null}>
                <EditMember
                    record={editRecord}
                    onFinish={() => {
                        setIsModalOpen(false)
                        setRefreshData(p => !p)
                    }}
                ></EditMember>
            </Modal>
            <AntTable
                Filter={<Filter setFilters={onFilters} />}
                refresh={refreshData}
                menuOptions={[{
                    label: `Export Excel - ${filters?.year && moment().set('month', filters?.month - 1).year(filters?.year).format('MMMM YYYY') || moment().format('MMMM YYYY')}`,
                    key: 'export'
                }]}
                menuClick={(e) => {
                    if (e.key == 'create') {
                        setEditRecord({});
                        setIsModalOpen(true)
                    } else if (e.key == 'export') {
                        exportReport();
                    }
                }}
                search
                title="Manage Member"
                columns={columns}
                onLoadData={onLoadData}
            />
        </>
    )
}
